import React from "react";
import { FiClipboard, FiTrendingUp, FiSettings, FiCreditCard, FiBarChart2, FiSearch, FiGrid, FiBookOpen, FiBriefcase, FiHome } from "react-icons/fi";
import "./ClientImpactJourney.css";

interface ClientImpactJourneyProps {
  id?: string;
}

const steps = [
  { icon: FiSearch, title: "Capture", subtitle: "Collect interest" },
  { icon: FiClipboard, title: "Set Up", subtitle: "Structure your venture" },
  { icon: FiTrendingUp, title: "Launch", subtitle: "Go live online" },
  { icon: FiSettings, title: "Operate", subtitle: "Run workflows" },
  { icon: FiCreditCard, title: "Collect", subtitle: "Enable payments" },
  { icon: FiBarChart2, title: "Scale", subtitle: "Automate and grow" },
];

const useCases = [
  { icon: FiTrendingUp, title: "Startups" },
  { icon: FiGrid, title: "MSMEs" },
  { icon: FiClipboard, title: "Campuses" },
  { icon: FiCreditCard, title: "Retail & E-commerce" },
  { icon: FiBookOpen, title: "Education" },
  { icon: FiBriefcase, title: "Service Businesses" },
  { icon: FiHome, title: "Institutions" },
  { icon: FiGrid, title: "More" },
];

const ClientImpactJourney: React.FC<ClientImpactJourneyProps> = ({ id }) => {
  return (
    <section id={id} className="client-impact-journey">
      <div className="client-impact-section client-impact-top">
        <div className="client-impact-copy">
          <p className="eyebrow">STELLAR EXECUTION JOURNEY</p>
          <h2>
            From First Form
            <span>To <strong>Forward Motion</strong></span>
          </h2>
          <p className="description">
            Capture intent, launch your presence, run operations, enable payments and scale with guided automation
            all in one connected flow.
          </p>
          <a href="https://orbitone.live/" target="_blank" rel="noreferrer" className="text-link">
            See how it works <span aria-hidden="true">→</span>
          </a>
        </div>

        <div className="client-impact-steps" aria-label="Execution journey steps">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <React.Fragment key={step.title}>
                <div className="step-item">
                <div className="step-icon-wrap">
                  <Icon className="step-icon" />
                </div>
                <div className="step-number">{index + 1}</div>
                <div className="step-title">{step.title}</div>
                <div className="step-subtitle">{step.subtitle}</div>
                </div>
                {index < steps.length - 1 && <span className="step-connector" aria-hidden="true" />}
              </React.Fragment>
            );
          })}
        </div>
      </div>

      <div className="client-impact-section client-impact-bottom">
        <div className="client-impact-copy">
          <p className="eyebrow">BUILT FOR</p>
          <h2>
            Designed for
            <span>modern ventures</span>
          </h2>
          <p className="description">
            Flexible enough for early-stage founders, MSMEs, institutions and execution-focused teams.
          </p>
          <a href="#expertise" className="text-link">
            Explore use cases <span aria-hidden="true">→</span>
          </a>
        </div>

        <div className="use-case-grid">
          {useCases.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={item.title} className="use-case-card">
                <Icon className="use-case-icon" />
                <div className="use-case-title">{item.title}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ClientImpactJourney;
